import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  dialog: {
    width: 250,
    height: 400,
  },
  label: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    lineHeight: '14px',

    color: '#666666',
  },
  title: {
    padding: 0,
    margin: 'auto 0 8px 0',
  },
  exportButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '16px',
    color: '#666666',
    lineHeight: '20px',
    top: 0,
    zIndex: 1,
    marginBottom: 16,
    paddingLeft: 0,
    textTransform: 'none',
  },
  loader: {
    color: '#DF0C36',
    position: 'fixed',
    left: '50%',
    top: '50%',
  },
}));
